// extracted by mini-css-extract-plugin
export var widgets = "cy_kd";